import CASL from '@/utils/constants/casl'

export default {
  path: 'inbox',
  name: 'inbox',
  meta: {
    action: 'read',
    subject: CASL.ACCESS.INBOX
  },
  component: () => import('./inbox/InboxPage.vue'),
  children: [
    {
      path: ':uuid',
      name: 'inbox.detail',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.INBOX
      },
      component: () => import('./inbox/components/detail/InboxDetail.vue')
    }
  ]
}
